import React, { useState } from "react";
import WeatherInfo from "./WeatherInfo";
import "./WeatherInfo";
import axios from "axios";
import "./Weather.css";



export default function Weather(props){
    const [weatherData, setWeatherData] = useState({ready: false});
    const[city, setCity] = useState(props.defaultCity);

    function search(){
        const apiKey = "588044cb65d7bcb3a78e6ef765b7879a";
        let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
        axios.get(apiUrl).then(handleResponse);
    }
    
    function handleSubmit(event){
        event.preventDefault();
        search();

    }

    function handleCityChange(event){
        setCity(event.target.value);
    }


    function handleResponse(response){
        setWeatherData({
            ready: true,
            temperature: response.data.main.temp,
            humidity: response.data.main.humidity,
            date: new Date(response.data.dt * 1000),
            description: response.data.weather[0].description,
            icon: response.data.weather[0].icon,
            wind: response.data.wind.speed,
            city: response.data.name,
        });
       
    }

    if (weatherData.ready){
        return (
            <div className="Weather">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-9">
                            <input 
                            type="search" 
                            placeholder="Type a city.." 
                            className="form-control" 
                            autoFocus="on" 
                            onChange={handleCityChange}
                            />
                        </div>
                        <div className="col-3">
                            <input 
                            type="submit" 
                            value="Search" 
                            className="btn btn-primary w-100"
                            />
                        </div>
                    </div>      
                </form> 
                <br />
                <WeatherInfo data={weatherData} />
            </div>
            );
        } else {
            search();
            return "Loading..";
        }
    }